// Gemeinsames Nivo-Theme: Schrift (Inter) & Farben aus dem App-Design,
// damit Diagramme, Legenden und Tooltips zum restlichen UI passen.
// Seit D3 eine Fabrik über das MUI-Theme — Achsen, Grid und Tooltip
// folgen damit automatisch dem aktiven Farbschema (hell/dunkel).
const FONT = '"Inter Variable", system-ui, -apple-system, "Segoe UI", Roboto, sans-serif';

const nivoTheme = (theme) => {
  const t = theme.palette.tokens;
  return {
    background: 'transparent',
    text: { fontFamily: FONT, fontSize: 12, fill: t.muted },
    axis: {
      ticks: { text: { fontFamily: FONT, fontSize: 11, fill: t.muted } },
      legend: { text: { fontFamily: FONT, fontSize: 12, fill: t.ink2 } },
    },
    legends: { text: { fontFamily: FONT, fontSize: 12, fill: t.ink2 } },
    labels: { text: { fontFamily: FONT } },
    grid: { line: { stroke: t.lineSoft, strokeWidth: 1 } },
    tooltip: {
      container: {
        fontFamily: FONT, fontSize: 12,
        background: t.surface, color: t.ink,
        borderRadius: 8,
        boxShadow: theme.palette.mode === 'dark'
          ? '0 6px 20px rgba(0,0,0,.5), 0 0 0 1px ' + t.line
          : '0 6px 20px rgba(14,26,43,.12)',
      },
    },
  };
};

export default nivoTheme;
